'use client'
import { useEffect, useState } from "react";
import Modal from "@/Component/Common/Modal";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CustomFetch from '@/Utils/APIRequest/AxiosInstance';
import { CardsAPI, SelfAPI } from '@/Utils/APIRequest/Endpoints';
import { useQuery } from '@tanstack/react-query';
import ActivePlanStepOne from "./ActivePlanStepOne";
import ActivePlanStepTwo from "./ActivePlanStepTwo";
import Loader from "@/Layout/Loader";
import { getUserDetails } from "@/lib/Features/UserDetails/userDetails";
import { useDispatch } from "react-redux";

let STRIPE_PUBLIC_KEY: any = process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

const ActivePlanModal = (props) => {
    const { modal, setModal, planRefetch, fromPayment = false, setCurrentPlan, translations, setPremiumModal, listRefetch, planTab, fromApproval = false, ManagementDetailRefetch, setApproveModalOpen, setMainModal, UserData, selfLoader, selfRefetch, isFromCampaignPayment = false, callBackFunction } = props;
    const dispatch = useDispatch();
    const [cardType, setCardType] = useState("card_list");

    // API GET
    const { data: CardData, isPending, refetch } = useQuery({ queryKey: [CardsAPI], queryFn: () => CustomFetch({ url: CardsAPI }, null, false), refetchOnWindowFocus: false, select: (data) => data?.data?.data })

    useEffect(() => {
        if (UserData) {
            dispatch(getUserDetails(UserData))
            setCurrentPlan && setCurrentPlan(UserData?.subscription?.[0])
        }
    }, [UserData?.subscription[0], selfLoader]);

    if (isPending) {
        return <Loader />
    }
    return (
        <Modal modalSize="w-96 max-w-4/5" modal={modal} setModal={setModal} >
            <Elements stripe={stripePromise}>
                {cardType == "card_list" && <ActivePlanStepOne modal={modal} cardType={cardType} setModal={setModal} setCardType={setCardType} CardData={CardData} refetch={refetch} selfRefetch={selfRefetch} planRefetch={planRefetch} fromPayment={fromPayment} translations={translations} setPremiumModal={setPremiumModal} listRefetch={listRefetch} planTab={planTab} fromApproval={fromApproval} ManagementDetailRefetch={ManagementDetailRefetch} setApproveModalOpen={setApproveModalOpen} setMainModal={setMainModal} isFromCampaignPayment={isFromCampaignPayment} callBackFunction={callBackFunction} />}
                {cardType == "add_card" && <ActivePlanStepTwo modal={modal} setModal={setModal} cardType={cardType} setCardType={setCardType} refetch={refetch} translations={translations} />}
            </Elements>
        </Modal>
    );
}

export default ActivePlanModal;